/**
 * Modal: blurred navy overlay, radius xl dialog with the xl shadow, white header (h1 type) with a rule beneath,
 * round close button, sunken footer with Back on the left / primary on the right (justify space-between).
 * Put an eyebrow (<Text textStyle="label" color="text.muted" aria-hidden>) as the first child of ModalHeader.
 */
export const Modal = {
  baseStyle: {
    overlay: { bg: "surface.overlay", backdropFilter: "blur(4px)", WebkitBackdropFilter: "blur(4px)" },
    dialog: { bg: "surface.card", borderRadius: "xl", boxShadow: "xl", mx: 4, overflow: "hidden", color: "text.primary" },
    header: {
      px: { base: 5, md: 8 },
      pt: { base: 5, md: 7 },
      pb: 5,
      fontFamily: "heading",
      fontSize: "1.5rem",
      fontWeight: 700,
      letterSpacing: "-0.015em",
      lineHeight: 1.2,
      color: "text.primary",
      borderBottom: "1px solid",
      borderColor: "border.rule",
    },
    closeButton: {
      top: 5,
      right: 5,
      borderRadius: "full",
      color: "text.muted",
      _hover: { bg: "sand.100", color: "text.primary" },
      _focusVisible: { boxShadow: "outline" },
    },
    body: { px: { base: 5, md: 8 }, py: 6 },
    footer: {
      px: { base: 5, md: 8 },
      py: 5,
      bg: "sand.50",
      borderTop: "1px solid",
      borderColor: "border.default",
      gap: 3,
      justifyContent: "space-between",
    },
  },
};
